import * as React from 'react';
import { Lock } from 'lucide-react';
import { cn } from '../lib/utils.js';

export interface LockedNoteProps {
  /** Pre-translated explanation of why the gated action isn't available. */
  children: React.ReactNode;
  className?: string;
  testId?: string;
}

/**
 * Inline note explaining why a permission-gated primary action is hidden,
 * shown next to the gated control instead of silently omitting it (so the
 * user learns why, not just that it's missing). Distinct from
 * `InlineErrorMessage`: no border/background box, meant to sit inline next
 * to a single action rather than as a standalone banner.
 */
export function LockedNote({ children, className, testId }: LockedNoteProps) {
  return (
    <span
      className={cn('inline-flex items-center gap-1.5 text-xs text-muted-foreground', className)}
      data-testid={testId}
    >
      <Lock className="h-3.5 w-3.5 shrink-0" />
      {children}
    </span>
  );
}
